import OneTeimePassword from "./OneTeimePassword";
import { useAppSelector } from "../../store/hooks";
import { LoginSteps } from "../../types/config";
import PhoneRequest from "./PhoneRequest";

const LoginProcess = () => {
  const { loginSteps } = useAppSelector((state) => state.config);
  return (
    <>
      {loginSteps === LoginSteps.PHONE && <PhoneRequest />}
      {loginSteps === LoginSteps.OTP && <OneTeimePassword />}
    </>
  );
};

export default LoginProcess;
